import { Drawer, Grid, Typography } from '@mui/material';
import React, { useState } from 'react'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyle from "../../../../../assets/styles/global.module.scss";
import chatLogsTemplatePreviewStyle from '../../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import CloseIcon from '@mui/icons-material/Close';

const ProductSentCartMessage = (props: any) => {
    
    const { productJson, targetRef } = props;

    const [openDrawer, setOpenDrawer] = useState<boolean>(false);

    const currencyTotals = productJson?.product_items?.reduce((acc: any, item: any) => {
        const {currency, item_price, quantity } = item;

        const total = item_price * quantity;
        acc[currency] = (acc[currency] || 0) + total;
        return acc;
    }, {});

    return (
        <>
            <Grid item key={targetRef} className={styles.viewSentCartMainGrid} sx={{position: "relative !important"}}>
                <Grid item className={styles.viewSentCartUpperContainer}>
                    <Grid container className={`${styles.viewSentCartMessageContainer} ${globalStyle.flexColumn} ${globalStyle.gapOne}`}>
                        <Grid item>
                            <Grid container gap={1}>
                                <Grid item className={globalStyle.displayFlexStyle}>
                                    <ShoppingCartIcon className={styles.productCartIcon} />
                                </Grid>
                                <Grid item>
                                    <Typography className={styles.sendCartTotalItemsTypography}>{productJson?.product_items?.length} items</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Typography className={styles.totalProductAmountTypography}>{Object.entries(currencyTotals).map(([currency, amount]) => `${currency} ${amount}`).join(' &')} (estimated total)</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={`${styles.viewSentCardBtnGrid} ${globalStyle.justifyCenter}`} onClick={() => setOpenDrawer(true)}>
                    <Grid item>
                        <Typography className={styles.viewSentCartBtn}>View sent cart</Typography>
                    </Grid>
                </Grid>
            
                <Drawer
                    open={openDrawer}
                    anchor='bottom'
                    ref={targetRef ? targetRef.current : ""}
                    onClose={() => setOpenDrawer(false)}
                    variant="temporary"
                    ModalProps={{
                        container: targetRef ? targetRef.current : "",
                        disableEnforceFocus: true,
                        style: { position: 'absolute' },
                        keepMounted: false,
                    }}
                    PaperProps={{
                        container: targetRef ? targetRef.current : "",
                        style: { position: 'absolute' },
                    }}
                    sx={{
                        transition: openDrawer ? 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                        position: "absolute"
                    }}
                    BackdropProps={{ style: { position: "absolute" } }}
                    SlideProps={{
                        direction: openDrawer ? "up" : "down",
                        timeout: { enter: 0, exit: 0 },
                        style: {
                            borderRadius: "32px 32px 0px 0px",
                            border: "2px solid #FAF0F0",
                            padding: "15px",
                            transition: openDrawer ? 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                        }
                    }}
                >
                    <Grid container direction={"column"} gap={"18px"} marginBottom={"15px"}>
                        <Grid item xs={12} className={`${chatLogsTemplatePreviewStyle.drawerContainerBoxStyle} ${globalStyle.displayFlexStyle} ${globalStyle.alignItemCenter}`} gap={"12px"}>
                            <CloseIcon className={`${chatLogsTemplatePreviewStyle.closeDrawerIconStyle} ${globalStyle.clickable}`} onClick={() => setOpenDrawer(false)} />
                            <span className={chatLogsTemplatePreviewStyle.allOptionTextStyle}>Your sent cart</span>
                        </Grid>
                    </Grid> 
                    {
                        productJson?.product_items?.length > 0 && productJson?.product_items?.map((product: any, ind: number) => {
                            return (
                            <Grid item padding={"10px"} className={`${chatLogsTemplatePreviewStyle.templatePreviewButtonItem} ${chatLogsTemplatePreviewStyle.templatePreviewButtonItemBorder}`}>
                                <Grid container justifyContent={"space-between"} gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                    <Grid item>
                                        <Typography className={styles.productRetailIdTypography}>Product Retailer ID: {product.product_retailer_id || ""}</Typography>
                                    </Grid> 
                                    <Grid item>
                                        <Grid container direction={"column"}>
                                            <Grid item>
                                                <Typography className={styles.productRetailIdTypography}>{product.currency} {product.item_price}</Typography>
                                            </Grid>
                                             <Grid item>
                                                <Typography className={styles.productRetailIdTypography}>Quantity {product.quantity}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            )
                        })
                    }
                    <Grid item className={chatLogsTemplatePreviewStyle.templatePreviewButtonItemBorder} padding={"10px"}>
                        <Typography className={`${styles.productRetailIdTypography} ${globalStyle.textItemsEnd}`}>{Object.entries(currencyTotals).map(([currency, amount]) => `${currency} ${amount}`).join(' &')} (estimated total)</Typography>
                    </Grid>
                </Drawer>
            </Grid> 

        </>
    )
}

export default ProductSentCartMessage
